import { Dialog, Markdown, useText } from "@sveabank/cc-common";
import type React from "react";
import FinalizeButtonGroup from "./finalize-button-group";

type Props = {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
};

const FinalizeModal: React.FC<Props> = ({ isOpen, setOpen }) => {
	const [t, texts] = useText();

	return (
		<Dialog
			size="small"
			center
			isOpen={isOpen}
			setOpen={setOpen}
			heading={t(texts.modals.finalizedApplication.title)}
			icon="success"
		>
			<Dialog.Content>
				<Markdown allowParagraphs>{t(texts.modals.finalizedApplication.body)}</Markdown>
			</Dialog.Content>
			<FinalizeButtonGroup onClose={() => setOpen(false)} />
		</Dialog>
	);
};

export default FinalizeModal;
